import { CheckSingleIcon } from '@grupoboticario/flora-react-icons';
import { ResponsiveFloraTypography } from 'ui/components/primitives';

import { formatString } from 'core/utilities';
import { ORDER_SUCCESS_TITLE_CONST } from './OrderSuccessTitle.d';
import { OrderSuccessTitle } from './OrderSuccessTitle.styles';
import { theme } from 'ui/theme';
import type { TitleProps } from './OrderSuccessTitle.d';

const OrderSuccessTitleBase = ({
  isPickupStore,
  orderCode,
  title,
  titleShippingModel,
}: TitleProps) => {
  const titleFormat = formatString(title, {
    orderId: orderCode,
  });

  return (
    <OrderSuccessTitle.Component data-testid={ORDER_SUCCESS_TITLE_CONST.TEST_ID}>
      <ResponsiveFloraTypography
        as="h1"
        color={`${theme.colors.action.nonInteractive.emphasis}`}
        fontSize="subtitle"
        css={{ margin: 0 }}
      >
        {' '}
        <CheckSingleIcon css={{ color: theme.colors.action.nonInteractive.emphasis }} size="64" />
        {titleFormat}
      </ResponsiveFloraTypography>
      {isPickupStore && (
        <ResponsiveFloraTypography
          as="h1"
          color={`${theme.colors.action.nonInteractive.emphasis}`}
          fontSize="subtitle"
          css={{ margin: 0 }}
        >
          {titleShippingModel}
        </ResponsiveFloraTypography>
      )}
    </OrderSuccessTitle.Component>
  );
};

export default OrderSuccessTitleBase;
